import React, {Fragment, useEffect, useRef, useState} from "react";
import {useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import {
    Alert,
    Button,
    Card,
    CardContent,
    Collapse,
    Divider,
    Grid,
    IconButton,
    Typography,
    TextField,
    FormControlLabel, RadioGroup, FormControl, FormHelperText
} from "@mui/material";
import dayjs, {Dayjs} from 'dayjs';
import Stack from '@mui/material/Stack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CustomTextFieldGrid from "../Custom/CustomTextFieldGrid";
import '../../App.css';
import FormValidator from "../../utils/FormValidator";
import EmployeeEmployerRegisterService from "../../services/EmployeeEmployerRegisterService";
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import {DatePicker} from "@mui/x-date-pickers";

const formValidator = new FormValidator();
const registerService = new EmployeeEmployerRegisterService();

const EmployeeEmployerForm = ({setEmployeeId}) => {

    const navigate = useNavigate();

    const name = useRef("");
    const surname = useRef("");
    const contactDetails = useRef("");
    const idNumber = useRef("");
    const emailRef = useRef("");
    const companyName = useRef("");
    const cipcRef = useRef("");
    const uRef = useRef("");

    // const radioButtonQuestionOnStillEmployed = useRef("");

    //const [employeeId, setEmployeeId] = useState();
    const [isRegistered, setIsRegistered] = useState();
    const [hasErrorOnFieldName, setHasErrorOnFieldName] = useState(false);
    const [hasErrorOnFieldSurname, setHasErrorOnFieldSurname] = useState(false);
    const [hasErrorOnFieldContactDetails, setHasErrorOnFieldContactDetails] = useState(false);
    const [hasErrorOnFieldIdNumber, setHasErrorOnFieldIdNumber] = useState(false);
    const [hasErrorOnFieldEmail, setHasErrorOnFieldEmail] = useState(false);
    const [hasErrorOnFieldCompanyName, setHasErrorOnFieldCompanyName] = useState(false);
    const [hasErrorOnFieldCIPC, setHasErrorOnFieldCIPC] = useState(false);
    const [hasErrorOnFieldUIF, setHasErrorOnFieldUIF] = useState(false);

    const [hasErrorYesOnBehalfRadioButton, setHasErrorYesOnBehalfRadioButton] = useState(false);
    const [hasErrorChceckedOnSameEmployerRadioButton, setHasErrorChceckedOnSameEmployerRadioButton] = useState(false);
    const [hasErrorChceckedOnDateOfEmploymentRadioButton, setHasErrorChceckedOnDateOfEmploymentRadioButton] = useState(false);

    const [value, setValue] = React.useState(null);
    const [isYesChceckedOnSubmission, setIsYesChceckedOnSubmission] = useState('');
    const [isNoChceckedOnSubmission, setIsNoChceckedOnSubmission] = useState('');
    const [isYesChceckedOnSameEmployer, setIsYesChceckedOnSameEmployer] = useState('');
    const [isNoChceckedOnSameEmployer, setIsNoChceckedOnSameEmployer] = useState('');
    const [isYesChceckedOnDateOfEmployment, setIsYesChceckedOnDateOfEmployment] = useState('');
    const [isNoChceckedOnDateOfEmployment, setIsNoChceckedOnDateOfEmployment] = useState('');

    const [openAlret, setOpenAlert] = useState(true);

    const submit = () => {
        let isSubmit = true;
        if(name.current.value.trim() === ""){
            setHasErrorOnFieldName("Please fill in the Name field");
            isSubmit = false;
        }
        if(surname.current.value.trim() === ""){
            setHasErrorOnFieldSurname("Please fill in the Surname field.");
            isSubmit = false;
        }
        if(contactDetails.current.value.trim() === ""){
            setHasErrorOnFieldContactDetails("Please fill in the Contact Details field.");
            isSubmit = false;
        }else{
            if(contactDetails.current.value.match(/^(\+\d{1,3}[- ]?)?\d{10}$/) && !(contactDetails.current.value.match(/0{5,}/))){
                setHasErrorOnFieldContactDetails(true);
            }else {
                setHasErrorOnFieldContactDetails("Invalid Contact Details.");
                isSubmit = false;
            }
        }
        if(idNumber.current.value.trim() === ""){
            setHasErrorOnFieldIdNumber("Please fill in the ID Number field.");
            isSubmit = false;
        }else{
            if(formValidator.checkId(idNumber.current.value) && idNumber.current.value.length === 13){
                setHasErrorOnFieldIdNumber(true);
            }else if(!formValidator.checkId(idNumber.current.value)){
                setHasErrorOnFieldIdNumber("Invalid ID Number.");
                isSubmit = false;
            }
        }
        if(emailRef.current.value.trim() === ""){
            setHasErrorOnFieldEmail("Please fill in the Email Address field.");
            isSubmit = false;
        }else{
            if(!new RegExp("^([a-zA-Z0-9_\\-\.]+)@([a-zA-Z0-9_\\-\.]+)\.([a-zA-Z]{2,5})$").test(emailRef.current.value)) {
                setHasErrorOnFieldEmail("Invalid Email Address.");
                isSubmit = false;
            }
        }
        if(companyName.current.value.trim() === ""){
            setHasErrorOnFieldCompanyName("Please fill in the Company Name field.");
            isSubmit = false;
        }
        if(isYesChceckedOnSubmission === '' && isNoChceckedOnSubmission === ''){
            setHasErrorYesOnBehalfRadioButton("Please select Yes or No");
            isSubmit = false;
        }
        if(isYesChceckedOnSameEmployer === '' && isNoChceckedOnSameEmployer === ''){
            setHasErrorChceckedOnSameEmployerRadioButton("Please select Yes or No");
            isSubmit = false;
        }
        if(isYesChceckedOnDateOfEmployment === '' && isNoChceckedOnDateOfEmployment === ''){
            setHasErrorChceckedOnDateOfEmploymentRadioButton("Please select Yes or No");
            isSubmit = false;
        }
        // if(cipcRef.current.value.trim() === ""){
        //     setHasErrorOnFieldCIPC("Please fill in the CIPC Number field.");
        //     // return;
        // }
        // if(uRef.current.value.trim() === ""){
        //     setHasErrorOnFieldUIF("Please fill in the UIF Ref Number field.");
        //     // return;
        // }

        if(isSubmit) {
            registerService.register({
                firstname: name.current.value,
                surname: surname.current.value,
                contactNumber: contactDetails.current.value,
                idNumber: idNumber.current.value,
                emailAddress: emailRef.current.value,
                onBehalfOf: isYesChceckedOnSubmission,
                stillEmployed: isYesChceckedOnSameEmployer,
                changedEmployment: isYesChceckedOnDateOfEmployment,
                changedEmploymentDate: value,
                employerDetails: {
                    companyName: companyName.current.value,
                    companyUifRefNumber: uRef.current.value,
                    cipcNo: cipcRef.current.value
                },
            }, setIsRegistered, setEmployeeId);
            navigate("/periodSelection");
        }
    };


    const onIdChangeHandler = (event) => {
        idNumber.current.value = idNumber.current.value.match('^[0-9]+$') ?
            idNumber.current.value : (idNumber.current.value.length != 1 ?
                idNumber.current.value.substring(0, idNumber.current.value.length -1) : '');
    };

    const onContactDetailsChangeHandler = () => {
        contactDetails.current.value = contactDetails.current.value.match('^[0-9]+$') ?
            contactDetails.current.value : (contactDetails.current.value.length != 1 ?
                contactDetails.current.value.substring(0, contactDetails.current.value.length -1) : '');
    };

    const radioButtonHandlerOnYesSubmission = () => {
        setIsYesChceckedOnSubmission(!isYesChceckedOnSubmission);
        setIsNoChceckedOnSubmission(false);
        setHasErrorYesOnBehalfRadioButton(false);
    }

    const radioButtonHandlerOnNoSubmission  = () => {
        setIsNoChceckedOnSubmission(!isNoChceckedOnSubmission);
        setIsYesChceckedOnSubmission(false);
        setHasErrorYesOnBehalfRadioButton(false);
    }

    const radioButtonHandlerOnYesSameEmployer = () => {
        setIsYesChceckedOnSameEmployer(!isYesChceckedOnSameEmployer);
        setIsNoChceckedOnSameEmployer(false);
        setHasErrorChceckedOnSameEmployerRadioButton(false);
    }

    const radioButtonHandlerOnNoSameEmployer  = () => {
        setIsNoChceckedOnSameEmployer(!isNoChceckedOnSameEmployer);
        setIsYesChceckedOnSameEmployer(false);
        setHasErrorChceckedOnSameEmployerRadioButton(false);
    }

    const radioButtonHandlerOnYesDateOfEmployment = () => {
        setIsYesChceckedOnDateOfEmployment(!isYesChceckedOnDateOfEmployment);
        setIsNoChceckedOnDateOfEmployment(false);
        setHasErrorChceckedOnDateOfEmploymentRadioButton(false);
    }

    const radioButtonHandlerOnNoDateOfEmployment = () => {
        setIsNoChceckedOnDateOfEmployment(!isNoChceckedOnDateOfEmployment);
        setIsYesChceckedOnDateOfEmployment(false);
        setHasErrorChceckedOnDateOfEmploymentRadioButton(false);
    }

    return (
        <Fragment>
            <Card variant="outlined" className={'employeeEmployerFrom'} sx={{display: 'inline-block', mx: '20px', transform: 'scale(0.8)'}}>
                <CardContent>
                    <Typography fontSize={30} sx={{marginLeft: 14, marginTop: 4, paddingRight: 0.08, fontWeight: 500}}
                                className={'dark-font-color'}>Welcome Employee</Typography>
                    <Divider className={'css-9mgopn-MuiDivider-root'} sx={{marginBottom: 10}}/>
                    <Collapse in={openAlret}>
                    <Alert severity={"success"} className={"form-alert"} action={
                        <IconButton aria-label="close" color="inherit" size="small" onClick={() => {setOpenAlert(false);}}>
                            <CloseIcon fontSize="inherit"/>
                        </IconButton>}>
                        <Typography fontSize={18} sx={{fontWeight: 100}} className={'dark-font-color'}>
                            Please fill in the form below: Your details and your company details.
                        </Typography>
                    </Alert>
                    </Collapse>

                    <Grid container>
                        <Grid item xs={12} lg={6}>
                            <Typography fontSize={18} sx={{fontWeight: 100, marginLeft: 14, paddingTop: 1.625}} className={'dark-font-color'}>
                                Are you submitting on behalf of someone else?
                            </Typography>
                            <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 62.5, marginTop: -3, color: 'red'}}>
                                *
                            </Typography>
                            <Grid className={'radioButtons_1'}>
                            <FormControl>
                                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                    <FormControlLabel value="true" control={<Radio checked={isYesChceckedOnSubmission} onChange={radioButtonHandlerOnYesSubmission}/>} label="Yes"/>
                                    <FormControlLabel value="false" control={<Radio checked={isNoChceckedOnSubmission} onChange={radioButtonHandlerOnNoSubmission}/>} label="No"/>
                                </RadioGroup>
                            </FormControl>
                                {hasErrorYesOnBehalfRadioButton && <FormHelperText sx={{color: 'red'}}>{hasErrorYesOnBehalfRadioButton}</FormHelperText>}
                            </Grid>
                            <Typography fontSize={30} sx={{marginLeft: 14, marginTop: 5, paddingRight: 0.08, fontWeight: 100}}
                                        className={'dark-font-color'}>Personal Information</Typography>
                            <Grid item sx={{marginLeft:15}}>
                                <CustomTextFieldGrid title={"Name"}
                                                     error={hasErrorOnFieldName.length > 0}
                                                     helperText={hasErrorOnFieldName}
                                                     onKeyPress={() => setHasErrorOnFieldName(false)}
                                                     myRef={name}
                                                     maxLength={50}
                                />
                                <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 6, marginTop: -6.8, color: 'red'}}>
                                    *
                                </Typography>
                            </Grid>
                            <Grid item sx={{marginLeft:15}}>
                                <Grid item>
                                    <CustomTextFieldGrid title={"Surname"}
                                                         error={hasErrorOnFieldSurname.length > 0}
                                                         helperText={hasErrorOnFieldSurname}
                                                         onKeyPress={() => setHasErrorOnFieldSurname(false)}
                                                         myRef={surname}
                                                         maxLength={50}
                                    />
                                    <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 8, marginTop: -6.8, color: 'red'}}>
                                        *
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item sx={{marginLeft:15}}>
                                <CustomTextFieldGrid title={"Contact No"}
                                                     error={hasErrorOnFieldContactDetails.length > 0}
                                                     helperText={hasErrorOnFieldContactDetails}
                                                     onKeyPress={() => setHasErrorOnFieldContactDetails(false)}
                                                     onChangeHandler={onContactDetailsChangeHandler}
                                                     myRef={contactDetails}
                                                     maxLength={10}
                                />
                                <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 10, marginTop: -6.8, color: 'red'}}>
                                    *
                                </Typography>
                            </Grid>
                            <Grid item sx={{marginLeft:15}}>
                                <CustomTextFieldGrid title={"ID Number"}
                                                     error={hasErrorOnFieldIdNumber.length > 0}
                                                     helperText={hasErrorOnFieldIdNumber}
                                                     onKeyPress={() => setHasErrorOnFieldIdNumber(false)}
                                                     myRef={idNumber}
                                                     maxLength={13}
                                                     onChangeHandler={onIdChangeHandler}/>
                            </Grid>
                            <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 25, marginTop: -6.8, color: 'red'}}>
                                *
                            </Typography>
                            <Grid item sx={{marginLeft:15}}>
                                <CustomTextFieldGrid title={"Email Address"}
                                                     error={hasErrorOnFieldEmail.length > 0}
                                                     helperText={hasErrorOnFieldEmail}
                                                     onKeyPress={() => setHasErrorOnFieldEmail(false)}
                                                     myRef={emailRef}
                                                     maxLength={50}
                                />
                                <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 12.5, marginTop: -6.8, color: 'red'}}>
                                    *
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <Typography fontSize={30} sx={{marginLeft: 14, marginTop: 15, paddingRight: 0.08, fontWeight: 100}}
                                        className={'dark-font-color'}>Company Details</Typography>

                            <Grid item sx={{marginLeft:15}}>
                                <Grid item>
                                    <CustomTextFieldGrid title={"Company Name"}
                                                         error={hasErrorOnFieldCompanyName}
                                                         helperText={hasErrorOnFieldCompanyName}
                                                         onKeyPress={() => setHasErrorOnFieldCompanyName(false)}
                                                         myRef={companyName}
                                                         maxLength={30}
                                    />
                                    <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 14, marginTop: -6.8, color: 'red'}}>
                                        *
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item sx={{marginLeft:15}}>
                                <Grid item>
                                    <CustomTextFieldGrid title={"UIF Reference No"}
                                        // error={hasErrorOnFieldUIF}
                                        // helperText={hasErrorOnFieldUIF}
                                                         onKeyPress={() => setHasErrorOnFieldUIF(false)}
                                                         maxLength={20}
                                                         myRef={uRef}/>
                                </Grid>
                            </Grid>
                            <Grid item sx={{marginLeft:15}}>
                                <Grid item>
                                    <CustomTextFieldGrid title={"CIPC No"}
                                        // error={hasErrorOnFieldCIPC}
                                        // helperText={hasErrorOnFieldCIPC}
                                                         onKeyPress={() => setHasErrorOnFieldCIPC(false)}
                                                         myRef={cipcRef}
                                                         maxLength={20}
                                    />
                                </Grid>
                        </Grid>
                            <Typography fontSize={18} sx={{fontWeight: 100, marginLeft: 15, paddingTop: 5}} className={'dark-font-color'}>
                                Are you still employed with the same employer?
                            </Typography>
                            <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 65, marginTop: -3, color: 'red'}}>
                                *
                            </Typography>
                            <Grid className={'radioButtons_2'}>
                                <FormControl>
                                    <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                        <FormControlLabel value="true" control={<Radio checked={isYesChceckedOnSameEmployer} onChange={radioButtonHandlerOnYesSameEmployer} />} label="Yes"/>
                                        <FormControlLabel value="false" control={<Radio checked={isNoChceckedOnSameEmployer} onChange={radioButtonHandlerOnNoSameEmployer} />} label="No"/>
                                    </RadioGroup>
                                </FormControl>
                                {hasErrorChceckedOnSameEmployerRadioButton && <FormHelperText sx={{color: 'red'}}>{hasErrorChceckedOnSameEmployerRadioButton}</FormHelperText>}
                            </Grid>
                            <Typography fontSize={18} sx={{fontWeight: 100, marginLeft: 15, paddingTop: 3}} className={'dark-font-color'}>
                                Have you changed employment in the past 2 years?
                            </Typography>
                            <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 69, marginTop: -3, color: 'red'}}>
                                *
                            </Typography>
                            <Grid className={'radioButtons_3'}>
                                <FormControl>
                                    <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                        <FormControlLabel value="true" control={<Radio checked={isYesChceckedOnDateOfEmployment} onChange={radioButtonHandlerOnYesDateOfEmployment}/>} label="Yes"/>
                                        <FormControlLabel value="false" control={<Radio checked={isNoChceckedOnDateOfEmployment} onChange={radioButtonHandlerOnNoDateOfEmployment}/>} label="No"/>
                                    </RadioGroup>
                                </FormControl>
                                {hasErrorChceckedOnDateOfEmploymentRadioButton && <FormHelperText sx={{color: 'red'}}>{hasErrorChceckedOnDateOfEmploymentRadioButton}</FormHelperText>}
                            </Grid>
                            {isYesChceckedOnDateOfEmployment ?
                                <div>
                            <Typography fontSize={18} sx={{fontWeight: 100, marginLeft: 15, paddingTop: 3}} className={'dark-font-color'}>
                                Date of change employment
                            </Typography>
                                    <Typography fontSize={20} sx={{fontWeight: 100, marginLeft: 44.5, marginTop: -3, color: 'red'}}>
                                        *
                                    </Typography>
                            <Grid className={'radioButtons_4'}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        disableFuture={true}
                                        required={false}
                                        minDate={dayjs('2020-01-01')}
                                        maxDate={dayjs('2023-01-01')}
                                        inputFormat="YYYY-MM-DD"
                                        label="Date of change employment"
                                        openTo="year"
                                        views={["year", "month", "day"]}
                                        format="YYYY-MM-DD"
                                        value={value}
                                        onChange={(newValue) => {setValue(newValue);}}
                                        renderInput={(params) => <TextField {...params} />}/>
                                </LocalizationProvider>
                            </Grid>
                                </div>
                                    : false}
                            </Grid>
                        </Grid>
                    <Grid container justifyContent={"flex-end"}>
                        <Grid item><Button sx={{marginRight: 15.625, marginTop: 10}} onClick={submit}  className="btn white-font lower-case">Next</Button></Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Fragment>
    );

};

export default EmployeeEmployerForm;